var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('UserAccountContainer', {
    attrs: {
      "user": _vm.user,
      "plan": _vm.getActiveUserPlan,
      "sub": _vm.getActiveUserSubscription,
      "forClient": true,
      "isAdmin": _vm.isAdmin,
      "loadingMessages": _vm.loadingMessages,
      "loadingSubscriptions": _vm.loadingSubscriptions
    },
    on: {
      "reloadPage": _vm.loadPage
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-016253b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/Pages/UserMgmt/UserAccountMgmt.vue
// module id = p8d4
// module chunks = 2